export default {
    contentTitle: {
        guide: 'Hướng dẫn hoạt động',
        guideTooltip: 'Hoạt động là gì?',
    },
    modulePageTooltip: {
        tooltip: 'Cùng thực hiện sẽ tốt hơn!',
    },
    questionAccuracy: {
        realtime: 'Thời gian thực',
        perQuestion: 'Theo câu hỏi',
    },
};
